import type { ProductInputRaw } from '@/actions/admin/products'
import type { SortableCol } from '@lib/models/types'

export const FIELD_LABELS: Record<keyof ProductInputRaw, string> = {
  product_name: 'Product Name',
  country: 'Country Code',
  category: 'Category',
  price: 'Price',
  commission_percent: 'Commission %',
  images: 'Image URL',
  link: 'Buy URL',
  ingredients: 'Ingredients',
  barcode: 'Barcode',
  moisture: 'Hydration',
  sensitivity: 'Sensitivity',
  pigmentation: 'Pigmentation',
  elasticity: 'Elasticity',
  flagged_review: 'Flagged Review',
}

export const SORT_MAP: Record<string, SortableCol> = {
  product_name:   'productName',
  country:        'country',
  category:       'category',
  price:          'price',
  flagged_review: 'flaggedReview',
}

export const QUESTION_IMAGES: Record<string, { src: string; descKey: string }> = {
  'oilyDry.afterWashing':                    { src: 'flaky-skin_eamxbf',    descKey: 'oilyDry.afterWashingImageDescription' },
  'oilyDry.photoShine':                      { src: 'shiny-skin_vmyhbd',    descKey: 'oilyDry.photoShineImageDescription' },
  'oilyDry.cloggedPores':                    { src: 'clogged-pores_g9vsno', descKey: 'oilyDry.cloggedPoresImageDescription' },
  'oilyDry.largePores':                      { src: 'large-pores_yrfekb',   descKey: 'oilyDry.largePoresImageDescription' },
  'sensitiveResistant.redPimples':           { src: 'red-pimples_x9heto',   descKey: 'sensitiveResistant.redPimplesImageDescription' },
  'sensitiveResistant.acneRosaceaDiagnosis': { src: 'rosacea_czcxmk',       descKey: 'sensitiveResistant.acneRosaceaDiagnosisImageDescription' },
  'pigmentedNonPigmented.melasmaDiagnosis':  { src: 'melasma_ktijn9',       descKey: 'pigmentedNonPigmented.melasmaDiagnosisImageDescription' },
  'pigmentedNonPigmented.sunWorsensPatches': { src: 'dark-spots_udxm0c',    descKey: 'pigmentedNonPigmented.sunWorsensPatchesImageDescription' },
}
